export enum TSection {
	Matches = "matches",
	//** Used on desktop default type for live */
	Events = "events",
	PlayedEvents = "played-events",
	Highlights = "highlights",
	LiveStream = "live-stream",
	Upcoming = "upcoming",
	StaticUpcoming = "static-upcoming",
	MyFavoritesEvents = "my-favorites-events",
	MyFavoritesTournaments = "my-favorites-tournaments",
}
